import React, { Fragment, useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from 'react-router-dom'
import Axios from 'axios'
import Swal from 'sweetalert2'

export default function ResetPassword() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const {id, tokenresetpassword} = useParams()

    const [isUpdating, setIslogging] = useState(false)
    const [formState, setFormState] = useState({})
    const [passwordverify, setPasswordverify] = useState("")
    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)

    const checkValidation = (isPassVer, e) => {
        const confirmPass = e.target.value
        if(isPassVer){
            setPasswordverify(confirmPass)
        }else{
            setFormState({...formState, 'password': confirmPass})
        }
    }

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        if(formState.password === passwordverify && formState.password !== ''){
            if(formState.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,8}$/g)){
                await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/users/changepassword/'+id+'/'+tokenresetpassword , {password: formState.password})
                .then(() => {
                    setIslogging(false)
                    navigate(`/${t("url.auth.resetpasswordsuccess")}`)
                })
                .catch(() => {
                    setIslogging(false)
                    Swal.fire({showConfirmButton: true, icon: 'error', text: t('resetpassword.errorreset')})
                })
            }else{
                Swal.fire({showConfirmButton: true, icon: 'warning', text: t('users.passwordsnotvalid')})
                setIslogging(false)
            }
        }else{
            Swal.fire({showConfirmButton: true, icon: 'warning', text: t('users.passwordsnotmatch')})
            setIslogging(false)
        }
    }

    return (
        <Fragment>
            <header className="cabecera d-flex align-items-center px-4">
                <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" height={28} />
            </header>
            <Container fluid className='p-0 m-0'>
                <Row className='p-0 m-0 centro-auth'>
                    <Col md={7} className='d-none d-md-flex align-items-center justify-content-center aside-auth' style={{
                        background: 'linear-gradient(135deg, #0B0C0E 0%, #1A1B1E 100%)',
                    }}>
                        <div style={{maxWidth: 420, color: 'white', padding: 40}}>
                            <h1 style={{color: 'white', fontSize: 40, marginBottom: 16}}>{t('resetpassword.title')}</h1>
                            <p style={{fontSize: 16, opacity: 0.7, lineHeight: 1.6}}>{t('resetpassword.subtitle')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} className='d-flex align-items-center p-5'>
                        <Container className='login-form-container'>
                            <div className='login-brand'>
                                <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" />
                            </div>
                            <h1 className='login-title'>{t('resetpassword.title')}</h1>
                            <p className='login-subtitle'>{t('resetpassword.subtitle')}</p>
                            <Form className="formulario" onSubmit={handleSubmit}>
                                <Row className="mb-4">
                                    <Col className='sd-passwordview'>
                                        <Form.Label htmlFor='password'>{t('users.newpassword')}</Form.Label>
                                        <Form.Control
                                            type={showPasswordOne ? 'text' : 'password'}
                                            placeholder={t('users.setpassword')}
                                            onChange={(e) => checkValidation(false, e)}
                                        />
                                        <img className="sd-imageneye" src={showPasswordOne ? "/images/eyeclose.svg" : "/images/eyeopen.svg"} alt="eye" width={15} onClick={() => setShowPasswordOne(!showPasswordOne)} />
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col className='sd-passwordview'>
                                        <Form.Label htmlFor='password'>{t('users.passwordconfirm')}</Form.Label>
                                        <Form.Control
                                            type={showPasswordTwo ? 'text' : 'password'}
                                            placeholder={t('users.setpasswordconfirm')}
                                            onChange={(e) => checkValidation(true, e)}
                                        />
                                        <img className="sd-imageneye" src={showPasswordTwo ? "/images/eyeclose.svg" : "/images/eyeopen.svg"} alt="eye" width={15} onClick={() => setShowPasswordTwo(!showPasswordTwo)} />
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col>
                                        <p className="mb-0"><span className='fs-12 fw-400 ps-1'>{t('users.passwordneed1')}</span></p>
                                        <p className="password-list mb-0">
                                            <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                            <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                            <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                                        </p>
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col>
                                        <Button variant='primary' type="submit" className="w-100">
                                            {isUpdating
                                                ? <span className="spinner-border spinner-border-sm align-middle"></span>
                                                : <>{t('resetpassword.submit')}</>
                                            }
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}